export const formatCurrency = (value?: number) =>
  value !== null && `£${value?.toFixed(2)}`;
